/**
 * Парсит date-only строку 'yyyy-MM-dd' в Date локальной полуночи.
 * new Date('yyyy-MM-dd') трактует строку как UTC-полночь, поэтому в TZ с отрицательным
 * смещением календарный день уезжает на сутки назад — здесь дата строится по локальным компонентам.
 */
export function parseLocalDate(dateRaw: string): Date {
  const [year, month, day] = dateRaw.split('T')[0].split('-').map(Number);

  return new Date(year, month - 1, day);
}

/**
 * Готовит дату для defaultSelectedDates у core-calendar-ui.
 * Кит парсит строку через new Date(): date-only 'yyyy-MM-dd' = UTC-полночь и в TZ с
 * отрицательным смещением уезжает на день назад. Время делает её локальной полуночью.
 */
export function toCalendarSelectedDate(date: string | null): string {
  return date ? `${date}T00:00:00` : '';
}
